import { render, staticRenderFns } from "./faceAssessment.vue?vue&type=template&id=643c1f7e&scoped=true"
import script from "./faceAssessment.vue?vue&type=script&lang=ts"
export * from "./faceAssessment.vue?vue&type=script&lang=ts"
import style0 from "./faceAssessment.vue?vue&type=style&index=0&id=643c1f7e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "643c1f7e",
  null
  
)

export default component.exports